import styles from '../components/table-pagination-sorting/styles/styles.module.css';
import React from 'react';

interface NestedTableProps {
    data: {
      receta: { receta: string };
      cantidad_producida: number;
      unidad_medida_producto: string;
      id_lote: string;
    }[];
  }
  
  const NestedTable: React.FC<NestedTableProps> = ({ data }) => {
    return (
      <table className={styles['nested-table']}>
        <thead>
          <tr>
            <th>Receta</th>
            <th>Cantidad</th>
            <th>Lote</th>
          </tr>
        </thead>
        <tbody>
          {data.map((receta, index) => (
            <tr key={index}>
              <td>{receta.receta.receta}</td>
              <td>{`${receta.cantidad_producida} ${receta.unidad_medida_producto}`}</td>
              <td>{receta.id_lote}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  
  export default NestedTable;